/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { Icon } from "frontend/src/components/Icon"

function Stars(props) {
  let rating = "0"

  if (props.rating) {
    rating = (((Math.round((props.rating * 10) / 5) * 5) / 10) * 20).toString() + "%"
  }

  return (
    <div sx={{ ...props.style, display: "flex", alignItems: "center" }}>
      <div sx={{ display: "flex", position: "relative" }}>
        <Icon name={props.name} color="#DDD" size={props.size}></Icon>
        <Icon name={props.name} color="#DDD" size={props.size}></Icon>
        <Icon name={props.name} color="#DDD" size={props.size}></Icon>
        <Icon name={props.name} color="#DDD" size={props.size}></Icon>
        <Icon name={props.name} color="#DDD" size={props.size}></Icon>

        <div
          sx={{
            display: "flex",
            position: "absolute",
            top: 0,
            overflow: "hidden",
            width: rating,
          }}
        >
          <Icon name={props.name} color="gold" size={props.size} sx={{ flexShrink: 0 }}></Icon>
          <Icon name={props.name} color="gold" size={props.size} sx={{ flexShrink: 0 }}></Icon>
          <Icon name={props.name} color="gold" size={props.size} sx={{ flexShrink: 0 }}></Icon>
          <Icon name={props.name} color="gold" size={props.size} sx={{ flexShrink: 0 }}></Icon>
          <Icon name={props.name} color="gold" size={props.size} sx={{ flexShrink: 0 }}></Icon>
        </div>
      </div>
    </div>
  )
}

export { Stars }
